"use client";

import { motion } from "framer-motion";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

interface SectionHeaderProps {
  badge?: string;
  badgeColor?: string; // legacy prop, ignored
  title: string;
  subtitle?: string;
  centered?: boolean;
  light?: boolean;
}

export function SectionHeader({
  badge,
  title,
  subtitle,
  centered = true,
  light = false,
}: SectionHeaderProps) {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      variants={stagger(0.09)}
      className={`flex flex-col gap-5 ${centered ? "items-center text-center" : ""}`}
    >
      {badge && (
        <motion.p
          variants={fadeUp}
          className={`flex items-center gap-3 text-xs font-bold uppercase tracking-widest ${
            light ? "text-paper/60" : "text-ink-faint"
          }`}
        >
          <span
            className={`w-1.5 h-1.5 shrink-0 ${light ? "bg-paper" : "bg-accent"}`}
            aria-hidden="true"
          />
          {badge}
        </motion.p>
      )}
      <motion.h2
        variants={fadeUp}
        className={`font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1] ${
          light ? "text-paper" : "text-ink"
        }`}
      >
        {title}
      </motion.h2>
      {subtitle && (
        <motion.p
          variants={fadeUp}
          className={`text-lg leading-relaxed max-w-2xl ${centered ? "mx-auto" : ""} ${
            light ? "text-paper/80" : "text-ink-soft"
          }`}
        >
          {subtitle}
        </motion.p>
      )}
    </motion.div>
  );
}
